/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class LayoutApi extends runtime.BaseAPI {
    /**
     * Remove tool from the layout
     * Clear Layout
     */
    async v2ClearLayoutRaw(requestParameters, initOverrides) {
        if (requestParameters['layoutId'] == null) {
            throw new runtime.RequiredError('layoutId', 'Required parameter "layoutId" was null or undefined when calling v2ClearLayout().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/layout/{layout_id}/clear`;
        urlPath = urlPath.replace(`{${"layout_id"}}`, encodeURIComponent(String(requestParameters['layoutId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Remove tool from the layout
     * Clear Layout
     */
    async v2ClearLayout(requestParameters, initOverrides) {
        const response = await this.v2ClearLayoutRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create Layouts
     */
    async v2CreateLayoutsRaw(requestParameters, initOverrides) {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError('tabId', 'Required parameter "tabId" was null or undefined when calling v2CreateLayouts().');
        }
        if (requestParameters['genericLayoutCreate'] == null) {
            throw new runtime.RequiredError('genericLayoutCreate', 'Required parameter "genericLayoutCreate" was null or undefined when calling v2CreateLayouts().');
        }
        const queryParameters = {};
        if (requestParameters['tabId'] != null) {
            queryParameters['tab_id'] = requestParameters['tabId'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/layout/multi`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['genericLayoutCreate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create Layouts
     */
    async v2CreateLayouts(requestParameters, initOverrides) {
        const response = await this.v2CreateLayoutsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete Layouts
     */
    async v2DeleteLayoutsRaw(requestParameters, initOverrides) {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError('requestBody', 'Required parameter "requestBody" was null or undefined when calling v2DeleteLayouts().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/layout/multi`;
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Delete Layouts
     */
    async v2DeleteLayouts(requestParameters, initOverrides) {
        const response = await this.v2DeleteLayoutsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Replace Layouts
     */
    async v2ReplaceTabLayoutsRaw(requestParameters, initOverrides) {
        if (requestParameters['tabId'] == null) {
            throw new runtime.RequiredError('tabId', 'Required parameter "tabId" was null or undefined when calling v2ReplaceTabLayouts().');
        }
        if (requestParameters['genericLayoutCreate'] == null) {
            throw new runtime.RequiredError('genericLayoutCreate', 'Required parameter "genericLayoutCreate" was null or undefined when calling v2ReplaceTabLayouts().');
        }
        const queryParameters = {};
        if (requestParameters['tabId'] != null) {
            queryParameters['tab_id'] = requestParameters['tabId'];
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/layout/multi/replace`;
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['genericLayoutCreate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Replace Layouts
     */
    async v2ReplaceTabLayouts(requestParameters, initOverrides) {
        const response = await this.v2ReplaceTabLayoutsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update Layouts
     */
    async v2UpdateLayoutRaw(requestParameters, initOverrides) {
        if (requestParameters['genericLayoutUpdate'] == null) {
            throw new runtime.RequiredError('genericLayoutUpdate', 'Required parameter "genericLayoutUpdate" was null or undefined when calling v2UpdateLayout().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/layout/multi`;
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['genericLayoutUpdate'],
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Update Layouts
     */
    async v2UpdateLayout(requestParameters, initOverrides) {
        const response = await this.v2UpdateLayoutRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
